import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import {
  BaseComponent,
  BaseEditFormModalComponent,
  Customer,
  CustomerService,
  ProductService,
  Supplier,
  TmsFormlyService,
} from 'tms-lib';
import { CustomerProductService } from 'tms-web-shared';

@Component({
  selector: 'app-product-customers-modal',
  templateUrl: './product-customers-modal.component.html',
  styleUrl: './product-customers-modal.component.scss',
})
export class ProductCustomersModalComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormModalComponent) form: BaseEditFormModalComponent;
  @Input() id: string;
  @Input() productId: string;

  fields: FormlyFieldConfig[];

  constructor(
    public customerProductService: CustomerProductService,
    private productService: ProductService,
    private customerService: CustomerService,
    private formlyService: TmsFormlyService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getFields();
  }

  private getFields() {
    this.fields = [
      ...this.formlyService.customerSearch(
        'customerSearch',
        'customerKey',
        undefined,
        (model: Customer) => this.changeCustomer(model),
        () => this.clearCustomer(),
      ),
      this.formlyService.text('customerKey', $localize`Customer Account`, undefined, {
        readonly: true,
        required: true,
      }),
      this.formlyService.text('customerName', $localize`Customer`, undefined, { readonly: true, required: true }),
      this.formlyService.checkbox('default', $localize`Default`, undefined, { required: true }),
      this.formlyService.text('partNo', $localize`Part Number`),
      this.formlyService.number('stdPrice', $localize`Price`, undefined, { required: true }, undefined, {
        'props.append': (field: FormlyFieldConfig) => field.model?.currencyCode,
      }),
      this.formlyService.number('stdCutPrice', $localize`Cut Price`, undefined, undefined, undefined, {
        'props.append': (field: FormlyFieldConfig) => field.model?.currencyCode,
      }),
      this.formlyService.number('minimumOrderQuantity', $localize`Minimum Order Quantity`),
    ];
  }

  saved() {
    this.productService.refreshDetails.next();
  }

  private changeCustomer(customer: Customer) {
    this.form.updateModel({
      customerId: customer.id,
      customerKey: customer.key,
      customerName: customer.name,
      currencyCode: customer.currencyCode,
    });
  }

  private clearCustomer() {
    this.form.updateModel({
      customerId: undefined,
      customerKey: undefined,
      customerName: undefined,
      customerAddressMultiLine: undefined,
      currencyCode: undefined,
    });
  }
}
